import { useClinicData } from "../clinic/clinicHooks";
import { FontEndFeatureFlags } from "@kahunmedical/common-configuration/dist/configuration/frontend";
import { ConfigSubObjectKeys } from "@kahunmedical/common-configuration/dist/generated";

/**
 * Autogenerate enum
 */
export const PatientFeatureFlagKeys: Partial<Record<
  keyof FontEndFeatureFlags,
  keyof FontEndFeatureFlags
>> = Object.keys(FontEndFeatureFlags).reduce((acc, k) => {
  acc[k] = k;
  return acc;
}, {});

export const usePatientFeatureFlags = (flagName: keyof FontEndFeatureFlags) => {
  const { settings } = useClinicData();

  // TEMP solution for non debug in explorer
  if (
    flagName === "debugSheet" &&
    window.location.href.includes("wconversationcase")
  )
    return false;

  const configObjectForKey = settings?.makeConfigObjectForKey?.(
    FontEndFeatureFlags,
    ConfigSubObjectKeys.fe,
  );

  return configObjectForKey?.[flagName] || false;
};
